/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InterrogatoryQueryCaseFile,
    InterrogatoryQueryCaseFileFromJSON,
    InterrogatoryQueryCaseFileFromJSONTyped,
    InterrogatoryQueryCaseFileToJSON,
    InterrogatoryQueryFolderInfo,
    InterrogatoryQueryFolderInfoFromJSON,
    InterrogatoryQueryFolderInfoFromJSONTyped,
    InterrogatoryQueryFolderInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface InterrogatoryQueryProcessingData
 */
export interface InterrogatoryQueryProcessingData {
    /**
     * 
     * @type {number}
     * @memberof InterrogatoryQueryProcessingData
     */
    inputTokenCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InterrogatoryQueryProcessingData
     */
    outputTokenCount?: number;
    /**
     * 
     * @type {Array<InterrogatoryQueryFolderInfo>}
     * @memberof InterrogatoryQueryProcessingData
     */
    folders?: Array<InterrogatoryQueryFolderInfo> | null;
    /**
     * 
     * @type {Array<InterrogatoryQueryCaseFile>}
     * @memberof InterrogatoryQueryProcessingData
     */
    files?: Array<InterrogatoryQueryCaseFile> | null;
}

export function InterrogatoryQueryProcessingDataFromJSON(json: any): InterrogatoryQueryProcessingData {
    return InterrogatoryQueryProcessingDataFromJSONTyped(json, false);
}

export function InterrogatoryQueryProcessingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterrogatoryQueryProcessingData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inputTokenCount': !exists(json, 'inputTokenCount') ? undefined : json['inputTokenCount'],
        'outputTokenCount': !exists(json, 'outputTokenCount') ? undefined : json['outputTokenCount'],
        'folders': !exists(json, 'folders') ? undefined : (json['folders'] === null ? null : (json['folders'] as Array<any>).map(InterrogatoryQueryFolderInfoFromJSON)),
        'files': !exists(json, 'files') ? undefined : (json['files'] === null ? null : (json['files'] as Array<any>).map(InterrogatoryQueryCaseFileFromJSON)),
    };
}

export function InterrogatoryQueryProcessingDataToJSON(value?: InterrogatoryQueryProcessingData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inputTokenCount': value.inputTokenCount,
        'outputTokenCount': value.outputTokenCount,
        'folders': value.folders === undefined ? undefined : (value.folders === null ? null : (value.folders as Array<any>).map(InterrogatoryQueryFolderInfoToJSON)),
        'files': value.files === undefined ? undefined : (value.files === null ? null : (value.files as Array<any>).map(InterrogatoryQueryCaseFileToJSON)),
    };
}


